import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Box, Icon } from "@zillow/constellation-10";
import { IconChevronRightOutline, IconChevronLeftOutline } from "@zillow/constellation-icons";
import { yieldCallback } from "@zillow/yield-callback";
const controlCss = {
  position: "absolute",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  top: "0",
  bottom: "0",
  // Literal (= ARROW_COLUMN_WIDTH) so Panda can extract it.
  width: "35px",
  zIndex: "5",
  _hover: {
    cursor: "pointer"
  }
};
const CarouselNavigation = ({
  onLeftButtonClick,
  onRightButtonClick
}) => /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsx(Box, { asChild: true, css: {
    ...controlCss,
    right: "0"
  }, children: /* @__PURE__ */ jsx("span", { "data-carousel-control": "next", onClick: yieldCallback(() => onRightButtonClick()), children: /* @__PURE__ */ jsx(Icon, { size: "sm", children: /* @__PURE__ */ jsx(IconChevronRightOutline, {}) }) }) }),
  /* @__PURE__ */ jsx(Box, { asChild: true, css: {
    ...controlCss,
    left: "0"
  }, children: /* @__PURE__ */ jsx("span", { "data-carousel-control": "previous", onClick: yieldCallback(() => onLeftButtonClick()), children: /* @__PURE__ */ jsx(Icon, { size: "sm", children: /* @__PURE__ */ jsx(IconChevronLeftOutline, {}) }) }) })
] });
export {
  CarouselNavigation as default
};
